import React from 'react'
import { Ripples } from '@uiball/loaders';

export default function Tag(props) {
  return (
    <p className='pt-[3px] pb-[2.0px] px-[4px] text-blue border-blue border-[1px] border-solid m-[0.2rem] text-[12px] rounded-full'
      style={{color: props.type === 'white' ? '#FBF3EB' : null, borderColor: props.type === 'white' ? '#FBF3EB' : null}}>
      {
        props.text === "Ongoing"
        ? <div className="flex flex-row pt-[0.5px]">
            <Ripples size={15} lineWeight={2.5} color={'#E05252'} speed={3.0}/>
            <div className='ml-[3px] mr-[7px] -mt-[0.5px]'>{props.text}</div>
          </div>
        : <div className='mx-[7px]'>{props.text}</div>
      }
    </p>
  )
}
